import styled from 'styled-components'
import { AccountModalLayout } from 'components/Layout/Account'
import { AccountResetPassword } from './AccountResetPassword'
import { useState } from 'react'

interface IProps {
  handleCodeResend?: () => void
  handleChangePassword: (oldPasswordOrResetCode: string, newPassword: string) => void
  isLoadingChangePassword?: boolean
  showOptionalButton?: boolean
  onCloseModal?: () => void
}

export const ChangePasswordModal = ({
  handleCodeResend,
  handleChangePassword,
  onCloseModal,
  isLoadingChangePassword = false,
  showOptionalButton = true,
}: IProps) => {
  const [newPassword, setNewPassword] = useState('')
  const [passwordResetCode, setPasswordResetCode] = useState('')

  return (
    <AccountModalLayoutSyled showCloseButton={true} onClose={onCloseModal}>
      <AccountResetPasswordStyled
        title="Change Password"
        passwordLabel="Current Password"
        newPassword={newPassword}
        setNewPassword={setNewPassword}
        passwordResetCode={passwordResetCode}
        setPasswordResetCode={setPasswordResetCode}
        handleCodeResend={handleCodeResend || (() => null)}
        handleChangePassword={handleChangePassword}
        showResendCodeButton={false}
        isInputTypePassword={true}
        isLoadingChangePassword={isLoadingChangePassword}
        showOptionalButton={showOptionalButton}
        showExtraRequirement={true}
      />
    </AccountModalLayoutSyled>
  )
}

const AccountResetPasswordStyled = styled(AccountResetPassword)`
  .input-container {
    input {
      text-align: left;
    }
  }
`

const AccountModalLayoutSyled = styled(AccountModalLayout)`
  padding: 2.75rem ${({ theme }) => theme.util.pixelToRem(85)} !important;
  header.title {
    margin: 0rem 0rem 1.5rem 0rem;
  }
`
